import { ADD_ITEM_DROPPABLE_PREFIX, NEW_SUB_UNIT_DROPPABLE_PREFIX, NEW_TU_DROPPABLE_ID } from '../constants';

export type DropTarget =
  | { kind: 'new-tu' }
  | { kind: 'add-item'; tuId: string }
  | { kind: 'new-sub-unit'; tuId: string };

export const parseDropTarget = (over: string): DropTarget | null => {
  if (over === NEW_TU_DROPPABLE_ID) {
    return { kind: 'new-tu' };
  }
  if (over.startsWith(ADD_ITEM_DROPPABLE_PREFIX)) {
    return { kind: 'add-item', tuId: over.slice(ADD_ITEM_DROPPABLE_PREFIX.length) };
  }
  if (over.startsWith(NEW_SUB_UNIT_DROPPABLE_PREFIX)) {
    return { kind: 'new-sub-unit', tuId: over.slice(NEW_SUB_UNIT_DROPPABLE_PREFIX.length) };
  }
  return null;
};
